import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", path: "/" },
  { label: "漫画分类大全", path: "/category" },
  { label: "漫画排行榜", path: "/category" },
  { label: "推荐文章", path: "/category" },
  { label: "关于我们", path: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b border-background-200/70 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 shadow-none backdrop-blur" : "bg-background-50/80 backdrop-blur"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2" aria-label="漫画分类大全 首页">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-2-line text-xl" />
          </span>
          <span className="font-heading text-xl text-primary-600 md:text-2xl">漫途导航</span>
          <span className="hidden rounded-full bg-accent-100 px-2 py-0.5 text-xs text-accent-800 sm:inline-block">
            漫画分类大全
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.label}
              to={item.path}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-4 py-2 text-sm transition-colors ${
                  isActive && item.path !== "/category"
                    ? "bg-primary-100 text-primary-700 font-medium"
                    : "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/about"
            className="ml-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            加入收藏
          </Link>
        </nav>

        <button
          type="button"
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
        </button>
      </div>

      {open && (
        <nav className="border-t border-background-200/70 bg-background-50 px-4 pb-4 pt-2 md:hidden" aria-label="移动端导航">
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.label}
                to={item.path}
                className={({ isActive }) =>
                  `rounded-md px-4 py-2.5 text-sm ${
                    isActive && item.path !== "/category"
                      ? "bg-primary-100 font-medium text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/about"
              className="mt-1 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-center text-sm font-medium text-background-50"
            >
              加入收藏
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}